<template>
  <header class="headerv2">
    <div class="inner">
      <div class="logo">
        <router-link :to="'/'"><img :src="logoImage" /></router-link>
      </div>
      <div class="ri">
        <el-input placeholder="请输入关键词" class="t-search" v-model="word" @change="search()">
          <el-select v-model="keys" slot="prepend" class="ou-sr-select">
            <el-option label="全部资源" value="1"></el-option>
            <el-option label="馆藏资源" value="2"></el-option>
          </el-select>
          <template slot="append">
            <div @click="search()" style="cursor: pointer;"><i class="el-icon-search"></i>搜索</div>
          </template>
        </el-input>
        <div class="denlu-info" v-if="member">
          <div class="s-img" @click="$com.toPath('/UserInfo')">
            <img :src="member.headImageUrl ? http.getImg(member.headImageUrl) : '/static/img/tx.jpg'">
          </div>
          <div class="s-info">
            <div class="uname">{{ member.userName }}</div>
            <div class="exit" @click="logout()">退出登录</div>
          </div>
        </div>
        <div class="denlu-btn" v-else-if="isadmin">
          <span @click="$com.showLogin(1)">登录</span>|<span @click="$com.showLogin(2)">注册</span>
          <Login />
        </div>
        <div class="denlu-btn" v-else-if="this.loginType == 'sso'">
          <span @click="$com.toSso()">登录</span>
        </div>
        <div class="denlu-btn" v-else>
          <span @click="$com.showLogin(1)">登录</span>|<span @click="$com.showLogin(2)">注册</span>
          <Login />
        </div>
        <div class="other-option" @click="$com.toPath('/MyCollect')">
          <i class="icon iconfont icon-bookshelf"></i>我的书架
        </div>
        <div class="other-option" @click="$com.toPath('/Help')"><i class="icon iconfont icon-help"></i>帮助</div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';

import Login from "common/login/Login";
import config from '../../../config';

export default {
  name: "HeadView",
  components: {
    Login,
  },
  computed: {
  },
  data() {
    return {
      member: this.$com.getMember(),
      keys: this.$route.query.keys ? this.$route.query.keys : "1",
      word: this.$route.query.word ? this.$route.query.word : "",
      logoImage: require('@/assets/logo.svg'),
      isadmin: this.$com.getParamFromQueryString('isadmin'),
      loginType: config.release.loginType
    }
  },
  mounted() {
    this.$api.GetOrgCover({ id: this.$com.orgId() }).then((res) => {
      if (res.code != 1 || !res.data) {
        return;
      }
      this.logoImage = this.http.getImg(res.data);
      console.log('3', this.logoImage)
    })
    setInterval(this.checkLocalStorageChange, 1000);
  },
  methods: {
    checkLocalStorageChange() {
      if (window.localStorage.Token) {
        let userInfo = {}
        this.$store.commit("saveToken", window.localStorage.Token);
        userInfo = this.jwt_decode(window.localStorage.Token);
        const now = new Date();
        const unixTimestamp = Math.floor(now.getTime() / 1000);
        if (unixTimestamp > userInfo.exp) {
          this.$store.commit("saveToken", "");
          this.token = window.localStorage.Token
        }
      }
    },
    search() {
      var path = "/BookStore?keys=" + this.keys;
      if (this.word) {
        path += "&word=" + this.word
      }
      location.href = location.origin + path;
    },
    logout() {
      this.$com.delToken();
      window.location.href = "/";
    }
  },
  watch: {
    $route(to, from) {
      this.keys = to.query.keys ? to.query.keys : '1';
      this.word = to.query.word;
    }
  },
};
</script>

<style lang="css" scoped>
.headerv2 {
  background-color: #3C9B9E;
  padding: 15px 0;
}

.headerv2 .inner,
.ri {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.headerv2 .inner {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.logo,
.logo a {
  width: 200px;
  height: auto;
  overflow: hidden;
}

.logo a {
  display: block;
  cursor: pointer;
}

.logo a img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.ri {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}

.t-search,
.denlu-btn {
  border-radius: 50px;
  background-color: rgba(255, 255, 255, .2);
  color: #ffffff;
  height: 40px;
  line-height: 40px;
  margin: 0 15px;
}

.t-search {
  width: 360px;
}

.denlu-btn {
  padding: 0 15px;
}

.denlu-btn span {
  padding: 0px 10px;
  cursor: pointer;
}

.other-option {
  margin: 0 15px;
  color: #fff;
  cursor: pointer;
}

.other-option .icon {
  font-size: 16px;
  padding-right: 5px;
}

.denlu-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  margin: 0 10px;
}

.denlu-info .s-img {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  overflow: hidden;
  background-color: #fff;
  cursor: pointer;
}

.denlu-info .s-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.denlu-info .s-info {
  margin-left: 10px;
}

.denlu-info .uname {
  color: #fff;
  max-width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.denlu-info .exit {
  width: 70px;
  height: 20px;
  line-height: 20px;
  background-color: #c6f1eb;
  color: #3C9B9E;
  text-align: center;
  margin-top: 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/common/head/HeadView.vue